import captionService from "CaptionService";
import type { CaptionRecord } from "./types";

export const passwordField: CaptionRecord = {
  capsLockMessage: () => captionService.getString("88627531-a681-43fa-9a83-f49734227373", "Caps Lock is on"),
};
